import "core-js/modules/es.array.includes.js";
import { defineAsyncComponent } from 'vue';
import { genFileId } from 'element-plus';
const scCropper = defineAsyncComponent(() => import('@/components/scCropper'));
import config from "@/config/upload";
import { ElMessage } from 'element-plus';
export default {
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: 148
    },
    width: {
      type: Number,
      default: 148
    },
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "el-icon-plus"
    },
    action: {
      type: String,
      default: ""
    },
    apiObj: {
      type: Object,
      default: () => {}
    },
    name: {
      type: String,
      default: config.filename
    },
    data: {
      type: Object,
      default: () => {}
    },
    accept: {
      type: String,
      default: "image/gif, image/jpeg, image/png"
    },
    maxSize: {
      type: Number,
      default: config.maxSizeFile
    },
    limit: {
      type: Number,
      default: 1
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    showFileList: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    onSuccess: {
      type: Function,
      default: () => {
        return true;
      }
    },
    cropper: {
      type: Boolean,
      default: false
    },
    compress: {
      type: Number,
      default: 1
    },
    aspectRatio: {
      type: Number,
      default: NaN
    }
  },
  components: {
    scCropper
  },
  data() {
    return {
      value: "",
      file: null,
      style: {
        width: this.width + "px",
        height: this.height + "px"
      },
      cropperDialogVisible: false,
      cropperFile: null
    };
  },
  watch: {
    modelValue(val) {
      this.value = val;
      this.newFile(val);
    },
    value(val) {
      this.$emit('update:modelValue', val);
    }
  },
  mounted() {
    this.value = this.modelValue;
    this.newFile(this.modelValue);
  },
  methods: {
    newFile(url) {
      if (url) {
        this.file = {
          status: "success",
          url: url
        };
      } else {
        this.file = null;
      }
    },
    cropperSave() {
      this.$refs.cropper.getCropFile(file => {
        file.uid = this.cropperFile.uid;
        this.cropperFile.raw = file;
        this.file = this.cropperFile;
        this.file.tempFile = URL.createObjectURL(this.file.raw);
        this.$refs.uploader.submit();
      }, this.cropperFile.name, this.cropperFile.type);
      this.cropperDialogVisible = false;
    },
    cropperClosed() {
      URL.revokeObjectURL(this.cropperFile.tempCropperFile);
      delete this.cropperFile.tempCropperFile;
    },
    handleRemove() {
      this.clearFiles();
    },
    clearFiles() {
      URL.revokeObjectURL(this.file.tempFile);
      this.value = "";
      this.file = null;
      this.$nextTick(() => {
        this.$refs.uploader.clearFiles();
      });
    },
    change(file, files) {
      if (files.length > 1) {
        files.splice(0, 1);
      }
      if (this.cropper && file.status == 'ready') {
        const acceptIncludes = ["image/gif", "image/jpeg", "image/png"].includes(file.raw.type);
        if (!acceptIncludes) {
          this.$notify.warning({
            title: '上传文件警告',
            message: '选择的文件非图像类文件'
          });
          return false;
        }
        this.cropperFile = file;
        this.cropperFile.tempCropperFile = URL.createObjectURL(file.raw);
        this.cropperDialogVisible = true;
        return false;
      }
      this.file = file;
      if (file.status == 'ready') {
        file.tempFile = URL.createObjectURL(file.raw);
      }
    },
    before(file) {
      const acceptIncludes = this.accept.replace(/\s/g, "").split(",").includes(file.type);
      if (!acceptIncludes) {
        this.$notify.warning({
          title: '上传文件警告',
          message: '选择的文件非图像类文件'
        });
        this.clearFiles();
        return false;
      }
      const maxSize = file.size / 1024 / 1024 < this.maxSize;
      if (!maxSize) {
        ElMessage.warning(`上传文件大小不能超过 ${this.maxSize}MB!`);
        this.clearFiles();
        return false;
      }
    },
    handleExceed(files) {
      const file = files[0];
      file.uid = genFileId();
      this.$refs.uploader.handleStart(file);
    },
    success(res, file) {
      //释放内存删除blob
      URL.revokeObjectURL(file.tempFile);
      delete file.tempFile;
      var os = this.onSuccess(res, file);
      if (os != undefined && os == false) {
        this.$nextTick(() => {
          this.file = null;
          this.value = "";
        });
        return false;
      }
      // var response = config.parseData(res)
      // console.log(response);
      file.url = res.data[0].web_path;
      this.value = file.url;
    },
    error(err) {
      this.$nextTick(() => {
        this.clearFiles();
      });
      this.$notify.error({
        title: '上传文件未成功',
        message: err
      });
    },
    request(param) {
      var apiObj = config.apiObj;
      if (this.apiObj) {
        apiObj = this.apiObj;
      }
      const data = new FormData();
      data.append(param.filename, param.file);
      for (const key in param.data) {
        data.append(key, param.data[key]);
      }
      apiObj.post(data, {
        onUploadProgress: e => {
          const complete = parseInt(e.loaded / e.total * 100 | 0, 10);
          param.onProgress({
            percent: complete
          });
        }
      }).then(res => {
        var response = config.parseData(res);
        if (response.code == config.successCode) {
          param.onSuccess(res);
        } else {
          param.onError(response.msg || "未知错误");
        }
      }).catch(err => {
        param.onError(err);
      });
    }
  }
};